var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        [
          _vm._v("基础信息 "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              !_vm.isVerify && _vm.info.status === "wait"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:BusinessStockLockIndex_Abandon",
                          arg: "BusinessStockLockIndex_Abandon",
                        },
                      ],
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.onStatus("abandon", _vm.info)
                        },
                      },
                    },
                    [_vm._v("作废")]
                  )
                : _vm._e(),
              _vm.isVerify && _vm.info.status === "wait"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:BusinessStockVerifyPlanIndex_Pass",
                          arg: "BusinessStockVerifyPlanIndex_Pass",
                        },
                      ],
                      staticClass: "main-btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onStatus("success", _vm.info)
                        },
                      },
                    },
                    [_vm._v("审核通过")]
                  )
                : _vm._e(),
              _vm.isVerify && _vm.info.status === "wait"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:BusinessStockVerifyPlanIndex_Reject",
                          arg: "BusinessStockVerifyPlanIndex_Reject",
                        },
                      ],
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.onStatus("fail", _vm.info)
                        },
                      },
                    },
                    [_vm._v("审核拒绝")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        { staticClass: "gray", attrs: { "label-width": "130px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "预留锁定单号" } }, [
                    _vm._v(" " + _vm._s(_vm.info.reserveCode) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.statusText") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              _vm.STOCK_LOCK_STATUS_LIST.bjGet(_vm.info.status)
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "仓库名称" } }, [
                    _vm._v(" " + _vm._s(_vm.info.warehouseName) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "仓库编码" } }, [
                    _vm._v(" " + _vm._s(_vm.info.warehouseCode) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "预计预留总数" } }, [
                    _vm._v(" " + _vm._s(_vm.info.planNum) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "实际预留总数" } }, [
                    _vm._v(" " + _vm._s(_vm.info.realNum) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "锁定生效时间" } }, [
                    _vm._v(" " + _vm._s(_vm.info.auditDate) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.createTimeText") } },
                    [_vm._v(" " + _vm._s(_vm.info.creationDate) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "创建人" } }, [
                    _vm._v(" " + _vm._s(_vm.info.createdName) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remarkText") } },
                    [_vm._v(" " + _vm._s(_vm.info.remark) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [_vm._v("商品明细 ")]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.info.reserveDetailResVOList || [],
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "55",
              align: "center",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "categoryName", label: "商品分类" },
          }),
          _c("el-table-column", {
            attrs: { prop: "spuCode", label: "商品编码" },
          }),
          _c("el-table-column", {
            attrs: { prop: "spuName", label: "商品名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "skuCode", label: "SKU编码" },
          }),
          _c("el-table-column", {
            attrs: { prop: "usableNum", label: "可预留库存" },
          }),
          _c("el-table-column", {
            attrs: { prop: "planNum", label: "预计预留数量" },
          }),
          _c("el-table-column", {
            attrs: { prop: "actuallyNum", label: "实际预留数量" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }